<template>
  <div class="filter-checkbox-list">
    <div class="filter-checkbox-item" :key="index" v-for="(item, index) in arrItems">
      <input
        class="do-filter"
        type="checkbox"
        :data-action="item.checked ? 'remove_filter_fund' : 'add_filter_fund'"
        :data-fundfiltertype="item.value"
        :value="item.value"
        v-model="item.checked"
        @change="toggleCheck($event)"
      />
      <span class="checkmark"></span>
      <label for>{{ item.title }}</label>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      arrVal: []
    };
  },
  props: {
    arrItems: {
      type: Array,
      default: []
    },
    defaultItem: {
      type: Array,
      default: []
    },
    alias: {
      type: String,
      default: ""
    },
    str: {
      type: String,
      default: ""
    }
  },
  watch: {
    async defaultItem(arr) {
      await this.generateCheckbox();
    }
  },
  async mounted() {
    await this.generateCheckbox();
    await this.applyQueryByParams();
  },
  methods: {
    toggleCheck(e) {
      this.$emit("select-data", this.arrItems, this.alias);
    },
    applyQueryByParams() {
      let type = [...this.$route.query.type];
      if (type.length && this.str === "ประเภท") {
        type.map(item => {
          this.$emit("select-data", this.arrItems, this.alias);
        });
      }
    },
    generateCheckbox() {
      var _this = this;
      if (this.defaultItem && this.defaultItem.length > 0) {
        for (let i = 0; i <= this.arrItems.length - 1; i++) {
          let findItem = this.defaultItem.find(function(e) {
            return e == _this.arrItems[i].value;
          });
          if (findItem) {
            _this.arrItems[i].checked = true;
          } else {
            _this.arrItems[i].checked = false;
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.filter-checkbox-list {
  display: inline-block;
  padding-top: 7px;

  height: 35px;
  box-sizing: border-box;
  .filter-checkbox-item {
    display: inline-block;
    margin-right: 24px;
    position: relative;
    label {
      margin-left: 28px;
      @extend %font-size-s;
    }
  }
}

input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 17px;
  width: 17px;
}

.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 17px;
  width: 17px;
  border: 2px solid #cccccc;
  box-sizing: border-box;
}

input ~ .checkmark {
  background-color: #ffffff;
  border-radius: 4px;
  pointer-events: none;
}

input:checked ~ .checkmark {
  background-color: $base-yellow;
  border: 2px solid $base-yellow;
  border-radius: 4px;
  pointer-events: none;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

input:checked ~ .checkmark:after {
  display: block;
}

.checkmark:after {
  left: 4px;
  top: -2px;
  width: 4px;
  height: 10px;
  border: solid white;
  border-width: 0 1.5px 1.5px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>


